import React from 'react'
import { withTheme } from 'material-ui/styles'
import MoreIcon from 'material-ui-icons/MoreHoriz'

const Circle = ({ value, more, theme, ...props }) => (
  <svg width={40} height={40} viewBox="0 0 512 512" {...props}>
    <circle cx={255} cy={255} r={230} fill="currentColor" />
    {more && (
      <g color={theme.palette.background.default}>
        <MoreIcon />
      </g>
    )}
    {!more && (
      <text
        x={255}
        y={246}
        alignmentBaseline="central"
        textAnchor="middle"
        fill={theme.palette.background.default}
        fontSize={125}
        fontWeight={300}
      >
        {value}
      </text>
    )}
  </svg>
)

export default withTheme()(Circle)



// WEBPACK FOOTER //
// ./src/assets/currencies/Circle.js